import { useState } from 'react';
import { adminApi } from '../../adminApi';
import { IconMail, IconArrowRight } from '../../components/Icon';
import { AdminHeader } from './ui';

export default function AdminEmail() {
  const [to,setTo]=useState(''); const [sub,setSub]=useState(''); const [msg,setMsg]=useState('Hello **{username}**, welcome to Vpnee!');
  const [busy,setBusy]=useState(false); const [out,setOut]=useState<string|null>(null);
  const [bSub,setBSub]=useState('Update from Vpnee'); const [bMsg,setBMsg]=useState('We have news for you…');
  const send=async()=>{
    setBusy(true); setOut(null);
    const r=await adminApi.sendEmail(to,sub,msg);
    setBusy(false); setOut(r.status===200 ? 'Sent via no-reply@tnidu.com (creative template)' : (r.data?.message||'Failed'));
  };
  const broadcast=async()=>{
    if(!confirm('Broadcast to ALL users? This sends real emails.')) return;
    setBusy(true); setOut(null);
    const r=await adminApi.broadcastEmail(bSub,bMsg);
    setBusy(false); setOut(r.status===200 ? `Broadcast queued: ${r.data?.sent||0} sent` : (r.data?.message||'Failed'));
  };
  return (
    <div>
      <AdminHeader icon={IconMail} title="Email" subtitle={<>All emails use the creative dark template (rose gradient, reply to hello@tnidu.com). Powered by <code>mail.tnidu.com</code>.</>} />
      {out && <div className="mb-4 px-3 py-2 rounded-xl bg-[color:var(--color-ok)]/15 border border-[color:var(--color-ok)]/30 text-sm">{out}</div>}

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="glass p-6">
          <h3 className="font-bold">Send single email</h3>
          <p className="text-xs text-[color:var(--color-ink-faint)]">Supports {'{username}'} and **bold** markdown.</p>
          <input value={to} onChange={e=>setTo(e.target.value)} placeholder="recipient@email.com" className="mt-3 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-4 py-2.5 text-sm" />
          <input value={sub} onChange={e=>setSub(e.target.value)} placeholder="Subject" className="mt-3 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-4 py-2.5 text-sm" />
          <textarea value={msg} onChange={e=>setMsg(e.target.value)} rows={6} placeholder="Message — use {username} and **bold**" className="mt-3 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-4 py-2.5 text-sm" />
          <button disabled={busy} onClick={send} className="btn btn-primary w-full mt-3 justify-center">{busy?'Sending…':'Send via creative template'}</button>
        </div>

        <div className="glass p-6 border-[color:var(--color-brand)]/30">
          <h3 className="font-bold text-[color:var(--color-brand-glow)]">Broadcast to all users</h3>
          <p className="text-xs text-[color:var(--color-ink-faint)]">Safety cap 500 per request, **bold** supported.</p>
          <input value={bSub} onChange={e=>setBSub(e.target.value)} placeholder="Broadcast subject" className="mt-3 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-4 py-2.5 text-sm" />
          <textarea value={bMsg} onChange={e=>setBMsg(e.target.value)} rows={6} className="mt-3 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-4 py-2.5 text-sm" />
          <button disabled={busy} onClick={broadcast} className="btn btn-primary w-full mt-3 justify-center">{busy?'Broadcasting…':'Broadcast to all'}</button>
        </div>
      </div>

      <div className="glass p-6 mt-6">
        <h3 className="font-bold">Preview — creative default template</h3>
        <div className="mt-3 rounded-2xl overflow-hidden border border-[color:var(--color-line)] bg-[#08040A] p-6">
          <div className="h-1 rounded-full mb-6" style={{background:'linear-gradient(90deg,#E8476A,#FFB0C1,#A11A35)'}} />
          <div className="text-[10px] uppercase tracking-widest text-[color:var(--color-ink-faint)]">TNIDU INC. · COLOMBO</div>
          <div className="chip mt-2">Vpnee — Post-quantum tunnel</div>
          <h2 className="h-title text-xl font-extrabold mt-3">Example subject</h2>
          <p className="text-sm text-[color:var(--color-ink-dim)] mt-3 leading-relaxed">Hey <span style={{color:'#FFB0C1', fontWeight:700}}>user</span>, this is how every email looks — dark, rose, reply to <a className="text-[color:var(--color-brand-glow)]">hello@tnidu.com</a>. All via <code>no-reply@tnidu.com</code>.</p>
          <div className="mt-4 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-white text-sm font-bold" style={{background:'linear-gradient(135deg,#E8476A,#A11A35)'}}>Call to action <IconArrowRight width={14} height={14} /></div>
        </div>
      </div>
    </div>
  );
}
